import { render, staticRenderFns } from "./BackgroundParrilla.vue?vue&type=template&id=48566e06&scoped=true&"
import script from "./BackgroundParrilla.vue?vue&type=script&lang=js&"
export * from "./BackgroundParrilla.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundParrilla.vue?vue&type=style&index=0&id=48566e06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48566e06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
installComponents(component, {VCarousel,VCarouselItem})
